<template>
  <WCCheckoutStage
    @checkout="$emit('checkout', $event)"
    :activeStage="activeStage"
    :stage="2"
    label="3. Receiving Your Order"
  >
    <WCSpinner v-if="isSyncing" class="mx-auto align-self-center" size="xl" />
    <WCOrderDetails
      v-else-if="!giftCardItems.length"
      @method="
        setShippingMethod($event);
        $emit('set-dirty', true);
      "
      @reservation="
        setReservation($event);
        $emit('set-dirty', true);
      "
      @continue="handleContinue"
      @goback="$emit('goback')"
      @form-changed="
        resetAddressStatus();
        setShipping($event);
        $emit('set-dirty', true);
      "
      @update:valid="$emit('update:valid', $event)"
      @removeitem="removeItem($event)"
      @removeallitems="removeAllItemsForSchedule($event)"
      :shipping="shipping"
      :shippingMethod="shippingMethod"
      :shippingMethods="shippingMethods"
      :reservationDate="reservationDate"
      :reservationTime="reservationTime"
      :lineItems="lineItems"
      :activeStage="activeStage"
    />
    <div class="d-flex justify-content-center mx-2" v-else>
      {{ $t('eGiftCardShippingAlert') }}
    </div>
  </WCCheckoutStage>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import MapService from '@/services/map.service';
import WCCheckoutStage from '../WCCheckoutStage/WCCheckoutStage.vue';
import WCOrderDetails from '../WCOrderDetails/WCOrderDetails.vue';

export default {
  components: { WCCheckoutStage, WCOrderDetails, WCSpinner },
  props: {
    activeStage: {
      type: Number,
      required: true,
    },
    shipping: {
      type: Object,
    },
    shippingMethod: {
      type: Object,
    },
    reservationDate: {
      type: String,
    },
    reservationTime: {
      type: String,
    },
    lineItems: {
      type: Array,
    },
    giftCardItems: {
      type: Array,
    },
  },
  data() {
    return {
      mapService: {},
    };
  },
  computed: {
    ...mapGetters({
      isSyncing: 'cart/isSyncing',
      shippingMethods: 'cart/getShippingMethods',
    }),
    shippingCountryString() {
      if (this.shipping?.country) {
        const foundCountry = this.$configuration.countries.find(
          country => country.id === this.shipping.country,
        );
        if (foundCountry) {
          return foundCountry.description;
        }
      }

      return '';
    },
    shippingStateString() {
      if (this.shipping?.state) {
        const foundState = this.$configuration.states.find(
          state => state.id === this.shipping.state,
        );
        if (foundState) {
          return foundState.description;
        }
      }

      return '';
    },
  },
  mounted() {
    this.resetAddressStatus();
  },
  methods: {
    ...mapActions({
      setReservation: 'cart/setReservation',
      setItemQuantity: 'cart/setItemQuantity',
    }),
    ...mapMutations({
      setShippingMethod: 'cart/SET_SHIPPING_METHOD',
      setShippingMethods: 'cart/SET_SHIPPING_METHODS',
      setShipping: 'cart/SET_SHIPPING',
    }),
    async handleContinue() {
      if (this.shippingMethod?.addressRequired && !this.shipping.latitude) {
        await this.determineLatLong();
      }

      this.$emit('checkout');
    },
    async determineLatLong() {
      this.mapService = new MapService();
      if (this.mapService) {
        await this.mapService.load();
        const { street1, city, postal } = this.shipping;
        const state = this.shippingStateString;
        const country = this.shippingCountryString;

        const geocoded = await this.mapService.geocode(
          `${street1}, ${city}, ${state} ${postal}, ${country}`,
        );

        if (geocoded?.latitude && geocoded?.longitude) {
          const newShipping = {
            ...this.shipping,
            latitude: geocoded.latitude,
            longitude: geocoded.longitude,
          };

          await this.setShipping(newShipping);
        }

        await this.mapService.unload();
      }
    },
    resetAddressStatus() {
      if (this.shippingMethod && this.shippingMethod.status === 'badaddress') {
        this.setShippingMethod({ ...this.shippingMethod, status: null });
      }

      if (this.shippingMethods && this.shippingMethods.find(m => m.status === 'badaddress')) {
        const newMethods = this.shippingMethods.map(method => {
          return method.status === 'badaddress' ? { ...method, status: null } : method;
        });

        this.setShippingMethods(newMethods);
      }
    },
    removeItem(lineItem) {
      this.setItemQuantity({
        item: lineItem.item,
        variation: lineItem.variation,
        quantity: 0,
      });

      this.$emit('checkout', 0);
    },
    removeAllItemsForSchedule({ scheduleName, restrictedLineItems }) {
      const lineItemsToRemove = restrictedLineItems[scheduleName];
      lineItemsToRemove.forEach(lineItem => {
        this.setItemQuantity({
          item: lineItem.item,
          variation: lineItem.variation,
          quantity: 0,
        });
      });

      this.$emit('checkout', 0);
    },
  },
};
</script>

<style lang="scss" scoped></style>
